<template>
  <div>
    <div v-if="busData" class="pt-2" :class="{ 'px-3': $vuetify.breakpoint.mdAndUp }">
      <Breadcrumbs
        :class="{ 'px-5 mt-2': $vuetify.breakpoint.smAndDown }"
        data="busData.name"
        :headline="busData.name"
        :link="[
          { text: 'Danh sách xe tuyến', href: '../busList' },
          { text: busData.name, id: busData.id },
        ]"
      />
      <v-card class="justify-space-between align-center my-4 pa-5 border" outlined>
        <v-row no-gutters>
          <v-col cols="12" md="2" class="mb-4">
            <span> Tên tuyến </span>
            <h4>{{ busData.name || '' }}</h4>
          </v-col>
          <v-col cols="12" md="2" class="mb-4">
            <div>Số HS tối đa</div>
            <div class="font-weight-bold">{{ $_get(busData, 'data.maxStudent', '-') }}</div>
          </v-col>
          <v-col cols="12" md="3" class="mb-4">
            <div>Lái xe</div>
            <div v-if="busData.driver" class="font-weight-bold">
              {{ busData.driver.name }} / <a :href="`tel:${busData.driver.phone}`">{{ busData.driver.phone }}</a>
            </div>
          </v-col>
          <v-col cols="12" md="3" class="mb-4">
            <div>Monitor</div>
            <div v-if="busData.monitor" class="font-weight-bold center">
              {{ busData.monitor.name }} / <a :href="`tel:${busData.monitor.phone}`">{{ busData.monitor.phone }}</a>
            </div>
            <div v-else class="font-weight-bold center">-</div>
          </v-col>
          <v-col cols="12" md="2" class="mb-4">
            <div>Tình trạng</div>
            <v-chip small class="white--text" v-if="busData.status" :color="busData.status | busStatusColor" label>
              {{ busData.status | busStatus }}
            </v-chip>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="d-flex justify-end mt-4">
            <v-btn class="search-button" @click="detailState = !detailState" outlined> Hồ sơ chi tiết </v-btn>
          </v-col>
        </v-row>
      </v-card>
      <BusScheduleTabs class="mt-8" />
      <div class="text-center">
        <v-btn class="ma-4" @click="remove" color="red" outlined>Xóa tuyến xe</v-btn>
      </div>
      <BusDetailDialog @edit="updateDialogState = !updateDialogState" :busData="busData" :state="detailState" />

      <bus-update-dialog :state="updateDialogState" :busData="busInfo"></bus-update-dialog>
    </div>
    <h1 v-else-if="!$loading.active">Bus not found</h1>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import BusScheduleTabs from '@/modules/bus/BusScheduleTabs.vue'
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import BusUpdateDialog from '@/modules/bus/BusUpdateDialog.vue'
import BusDetailDialog from '@/modules/bus/BusDetailDialog.vue'

export default {
  components: {
    Breadcrumbs,
    BusUpdateDialog,
    BusDetailDialog,
    BusScheduleTabs,
  },
  data() {
    return {
      updateDialogState: false,
      tab: null,
      detailState: false,
      dialog: false,
    }
  },
  computed: {
    ...mapGetters('busDetail', ['busData']),
    busInfo() {
      return this.busData
    },
  },
  methods: {
    ...mapActions('busDetail', ['initBus']),
    ...mapActions('bus', ['removeBus']),
    remove() {
      this.$dialog.confirm({
        title: 'Xác nhận xóa tuyến xe',
        text: 'Tuyến xe này sẽ bị xóa khỏi danh sách xe tuyến. Thao tác này sẽ không thể hoàn tác. Bạn có chắc chắn muốn xóa tuyến xe?',
        okText: 'OK',
        cancelText: 'Hủy',
        type: 'delete',
        done: async () => {
          try {
            await this.removeBus(this.busData.id)
            this.$alert.success('Xóa tuyến xe thành công!')
            this.$router.push(`/busList/`)
          } catch (error) {
            this.$alert.deleteError()
          } finally {
            this.$loading.active = false
          }
        },
      })
    },
  },
  async created() {
    this.$loading.active = true
    try {
      await this.initBus(this.$route.params.id)
    } catch (error) {
      console.error(error)
    } finally {
      this.$loading.active = false
    }
  },
}
</script>
<style scoped>
.theme--light.v-tabs-items {
  background-color: transparent;
}
td {
  padding-top: 4px;
}
td:first-child {
  padding-right: 48px;
}
</style>
